import React, { CSSProperties, useMemo } from 'react';
import { Grid, GridProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ExtGrid } from '..';
import { EntitiesStatisticContainer, EntitiesStatisticContainerProps } from '.';


const useStyle = makeStyles(() => {
    return {
        root: {
        },
    };
}, { name: 'MaintenanceDashboardStatsContainer', index: 1 });



export interface MaintenanceDashboardStatsContainerProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly projectId: number;
    readonly entitiesStatisticSettings: readonly EntitiesStatisticContainerProps['entitiesStatisticSettings'] [];
    readonly onItemClick?: (
        event: React.MouseEvent<HTMLElement, MouseEvent> | undefined,
        statsSettings: EntitiesStatisticContainerProps['entitiesStatisticSettings']
    )=> void | undefined;
}


/**
 * This component displayed the statistic for a set of entity classes. For each set of entity classes, it will use the
 * EntitiesStatisticContainer to display the statistic for just 1 set.
 */
export const MaintenanceDashboardStatsContainer: React.FC<MaintenanceDashboardStatsContainerProps> = (
    props: MaintenanceDashboardStatsContainerProps,
) => {
    const classes = useStyle();


    // Create the grid sizes based on the number of items in the project statistic settings
    const gridSizes = useMemo((): {
        readonly xs?: GridProps['xs'] | undefined;
        readonly md?: GridProps['md'] | undefined;
        readonly lg?: GridProps['lg'] | undefined;
        readonly xl?: GridProps['xl'] | undefined;
    } => {
        if (props.entitiesStatisticSettings.length >= 5) {
            return {
                xl: 2,
                lg: 3,
                md: 4,
                xs: 12,
            };
        }
        if (props.entitiesStatisticSettings.length >= 4) {
            return {
                lg: 3,
                md: 4,
                xs: 12,
            };
        }
        if (props.entitiesStatisticSettings.length >= 3) {
            return {
                md: 4,
                xs: 12,
            };
        }

        return {
            md: 6,
            xs: 12,
        };
    }, [props.entitiesStatisticSettings.length]);


    return (
        <div className={clsx(props.className, classes.root)}>
            <ExtGrid container xs_spacing={1} md_spacing={2} lg_spacing={3}>
                {props.entitiesStatisticSettings.map((entitiesStatsSettings) => {
                    return (
                        <Grid
                            key={`${entitiesStatsSettings.icon}-${entitiesStatsSettings.labelKey}-${entitiesStatsSettings.entityClasses.join()}`}
                            item
                            xs={gridSizes.xs}
                            md={gridSizes.md}
                            lg={gridSizes.lg}
                            xl={gridSizes.xl}
                        >
                            <EntitiesStatisticContainer
                                projectId={props.projectId}
                                entitiesStatisticSettings={entitiesStatsSettings}
                                onClick={(event: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => {
                                    if (props.onItemClick) {
                                        props.onItemClick(event, entitiesStatsSettings);
                                    }
                                }}
                            />
                        </Grid>
                    );
                })}
            </ExtGrid>
        </div>
    );
};
